import { useQuery, QueryFunction } from 'react-query';
import {
    SiteDailyReport,
    SiteDailyReportResponse,
    getSiteDailyReportBySiteAndDate,
    GetSiteDailyReportQueries,
} from '../../services/apiSLTP/dailyReports/siteDailyReports';

type UseSiteDailyReportBySiteAndDateQueryOptions = {
    siteId: string;
    date: string;
    enabled?: boolean;
};

const getSiteDailyReportBySiteAndDateQuery: QueryFunction<SiteDailyReport | undefined> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseSiteDailyReportBySiteAndDateQueryOptions];
    const { siteId, date } = options;

    const queries: GetSiteDailyReportQueries = {
        siteId,
        date,
    };

    const response = await getSiteDailyReportBySiteAndDate(queries);
    return response.data;
};

export const useSiteDailyReportBySiteAndDateQuery = (options: UseSiteDailyReportBySiteAndDateQueryOptions) => {
    return useQuery(['siteDailyReport', options], getSiteDailyReportBySiteAndDateQuery, {
        enabled: options.enabled !== false && !!options.siteId && !!options.date,
        retry: false,
    });
};
